import React, { useEffect, useState } from "react";
import { observer } from "mobx-react-lite";
import cx from "classnames";
import { Hooks } from "@xt/xtbase";
import store from "store";
import styles from "./index.module.scss";
import { Form, Input, Checkbox, Radio, message } from "antd";
import XtLoading from "@/components/Xt/Loading";
import { deepClone, setFormValue } from "@/utils/method";
import FormItemSection, { UplodaApiResProps } from "./FormItemSection";
import { FieldData } from "rc-field-form/lib/interface";
import { CheckboxChangeEvent } from "antd/lib/checkbox";
import { waitRes } from "@/utils/axios";
import { get_enterpriseMemberList, post_enterpriseMemberBatchSave, post_enterpriseMemberBatchSaveDraft } from "@/api/xt-user";
import XtBtntxt from "@/components/Xt/BtnTxt";
import XtSvg from "@/components/Xt/Svg";

interface P2Props extends BaseCompProps {
  attr?: any;
  enterpriseApplyId?: string;
  onStepChange?(step: number): void;
}
export interface FormItemSectionProps {
  isBeneficiary?: boolean;
  firstName: string; //名字
  lastName: string; //姓氏
  email: string; //邮箱地址
  mobileCountryId: string; //联系电话code
  mobile: string; //联系电话
  position: string; //公司职位
  countryId: string; //国家/地区
  cardType: number; //证件类型 1：身份证 2：护照
  cardCountryId: string; //证件签发国/地区
  cardFront: string; //证件正面
  cardBack: string; //证件反面
}
export interface FormDataProps {
  ents: FormItemSectionProps[];
}
const { useTranslation } = Hooks;
const { useForm } = Form;
const formItemSection: FormItemSectionProps = {
  isBeneficiary: false,
  firstName: "", //名字
  lastName: "", //姓氏
  email: "", //邮箱地址
  mobileCountryId: "", //联系电话code
  mobile: "", //联系电话
  position: "", //公司职位
  countryId: "", //国家/地区
  cardType: 1, //证件类型 1：身份证 2：护照
  cardCountryId: "", //证件签发国/地区
  cardFront: "", //证件正面
  cardBack: "", //证件反面
};
const initFormData: FormDataProps = {
  // ents是最终的obj-arr数据 默认两条
  ents: [{ ...formItemSection }, { ...formItemSection }],
};
const P2: React.FC<P2Props> = ({ className, enterpriseApplyId, onStepChange }) => {
  const t = useTranslation();
  const [formIns] = useForm();
  //const {isLogin} = store.user;
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState(deepClone(initFormData) as FormDataProps);
  const [beneficiary, setBeneficiary] = useState<number | null>(null);
  /**useEffect */
  useEffect(() => {
    store.user.getCountryInfo();
    init();
  }, []);
  useEffect(() => {
    formIns.setFieldsValue(formData);
  }, [formData]);

  /**method */
  const init = async () => {
    setLoading(true);
    const { data, err }: { data: FormDataProps["ents"]; err?: string } = await waitRes(get_enterpriseMemberList, {
      params: {
        enterpriseApplyId,
      },
    });
    setLoading(false);
    if (err || !data || !data.length) return;
    data.forEach((item, index) => {
      formData.ents[index] = { ...formData.ents[index], ...item };
    });
    const beneficiary = data.findIndex((item) => item.isBeneficiary);
    if (beneficiary > 0) setBeneficiary(beneficiary);
  };
  const onFieldsChange = (changedFields: FieldData[]) => {
    const data = setFormValue(formData, changedFields);
    if (!data) return;
    setFormData(data);
  };
  const uploadChange = (data: UplodaApiResProps, type: "cardFront" | "cardBack", index: number) => {
    formData.ents[index][type] = data.absolutePath;
    setFormData({ ...formData });
  };
  const onCheckBoxChange = (e: CheckboxChangeEvent) => {
    if (e.target.checked) {
      formData.ents[1] = deepClone(formData.ents[0]);
      setFormData({ ...formData });
    }
  };
  const onDel = (index: number) => {
    formData.ents.splice(index, 1);
    setFormData({ ...formData });
  };
  const onAdd = () => {
    formData.ents.push(deepClone(formItemSection));
    setFormData({ ...formData });
  };
  // 保存草稿
  const onSaveDraft = async () => {
    setLoading(true);
    formData.ents.forEach((item) => {
      item.isBeneficiary = false;
    });
    if (beneficiary) formData.ents[beneficiary].isBeneficiary = true;
    const { data, err } = await waitRes(post_enterpriseMemberBatchSaveDraft, {
      errorPop: true,
      params: {
        enterpriseApplyId,
      },
      data: formData.ents,
    });
    setLoading(false);
    if (err) return;
    message.success(t("ent.saveSuccess"));
  };

  // 保存
  const onSaveContinue = async () => {
    try {
      await formIns.validateFields();
      formData.ents.forEach((item) => {
        item.isBeneficiary = false;
      });
      if (beneficiary) formData.ents[beneficiary].isBeneficiary = true;
      setLoading(true);
      const { err } = await waitRes(post_enterpriseMemberBatchSave, {
        errorPop: true,
        params: {
          enterpriseApplyId,
        },
        data: formData.ents,
      });
      setLoading(false);
      if (err) return;
      onStepChange && onStepChange(3);
    } catch (error) {
      message.error(t("ent.errTip"));
    }
  };
  return (
    <div className={cx(styles["page-account-enterprise-p2"], className)}>
      <Form name="p2Form" layout="vertical" form={formIns} initialValues={formData} onFieldsChange={onFieldsChange}>
        <div>
          <div className={styles["page-account-enterprise--title"]}>{t("ent.comAuthBio")}</div>
          <FormItemSection index={0} formData={formData} uploadChange={uploadChange} />
        </div>
        <div style={{ marginTop: "30px" }}>
          <div className={styles["page-account-enterprise--title"]} style={{ marginBottom: "10px" }}>
            {t("ent.comDirector")}
          </div>
          <div className={styles["iInfo"]}>{t("ent.comDirectorTip")}</div>
          <div>
            <div className={styles["iSubNav"]}>
              <div>{t("ent.director")} 1</div>
              <Checkbox onChange={onCheckBoxChange}>{t("ent.keepSame")}</Checkbox>
            </div>
            <div style={{ marginBottom: "24px" }}>
              <div className={styles["color-theme"]} style={{ marginBottom: "8px" }}>
                {t("ent.isBeneficiary")}
              </div>
              <Radio.Group
                value={beneficiary === 1 ? 1 : null}
                onChange={(e) => setBeneficiary(e.target.value)}
                disabled={!!(beneficiary && beneficiary !== 1)}
              >
                <Radio value={1}>{t("ent.yes")}</Radio>
                <Radio value={null}>{t("ent.no")}</Radio>
              </Radio.Group>
            </div>
            <FormItemSection index={1} formData={formData} uploadChange={uploadChange} />
          </div>
          {/* 动态增减董事 */}
          {formData.ents.slice(2).map((item, i) => (
            <div key={i}>
              <div className={styles["iSubNav"]}>
                <div>
                  {t("ent.director")} {i + 2}
                </div>
                <XtBtntxt onClick={() => onDel(i)} style={{ color: "#B9F78A" }}>
                  {t("ent.delete")}
                </XtBtntxt>
              </div>

              <div style={{ marginBottom: "24px" }}>
                <div className={styles["color-theme"]} style={{ marginBottom: "8px" }}>
                  {t("ent.isBeneficiary")}
                </div>
                <Radio.Group
                  value={beneficiary === i + 2 ? i + 2 : null}
                  onChange={(e) => setBeneficiary(e.target.value)}
                  disabled={!!(beneficiary && beneficiary !== i + 2)}
                >
                  <Radio value={i + 2}>{t("ent.yes")}</Radio>
                  <Radio value={null}>{t("ent.no")}</Radio>
                </Radio.Group>
              </div>
              <FormItemSection index={i + 2} formData={formData} uploadChange={uploadChange} />
            </div>
          ))}
        </div>

        {formData.ents.length < 10 && (
          <XtBtntxt className={styles["iAddDirector"]} onClick={onAdd}>
            <XtSvg src={require("@/assets/icon-svg/account/add.svg")} />
            &nbsp; <span>{t("ent.addDirector")}</span>
          </XtBtntxt>
        )}
        <div className={styles["page-account-enterprise--btns"]}>
          <XtBtntxt className={styles["ghost"]} onClick={() => onStepChange && onStepChange(1)}>
            {t("ent.backPrev")}
          </XtBtntxt>
          <XtBtntxt className={styles["ghost"]} onClick={onSaveDraft}>
            {t("ent.saveDraft")}
          </XtBtntxt>
          <XtBtntxt onClick={onSaveContinue}>{t("ent.saveContinue")}</XtBtntxt>
        </div>
      </Form>
      {loading && <XtLoading />}
    </div>
  );
};
export default observer(P2);
